// @flow

import _ from 'lodash';
import React, { useEffect } from 'react';
import { Router, Route, Redirect } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Helmet } from 'react-helmet';
import { ErrorBoundary } from 'react-error-boundary';
import * as Sentry from '@sentry/browser';
import history from 'app/utils/history';
import { defaultLang, langList } from 'app/utils/lang';
import store from 'app/redux/store';
import 'app/app/assets/js/webOSTV';
import KeyControl from './KeyControl';

let lang = defaultLang();
const [fistPart, urlLang] = ((window.location.pathname).split('/'));
const storedLang = localStorage.getItem('lang');
const defaultLangList = langList();

if (fistPart && urlLang && defaultLangList.includes(urlLang)) {
  lang = urlLang;
} else if (storedLang && defaultLangList.includes(storedLang)) {
  lang = storedLang;
}

localStorage.setItem('lang', lang);

const ErrorFallback = ({
  error,
} : {
  error : {
    message : string,
  },
}) => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && process.env.SKIP_SENTRY !== 'false') {
      if (!(/Loading chunk [\d]+ failed/.test(error.message))) {
        Sentry.captureException(`CRASH: ${error.message}`);
      }
      history.push('/');
      window.location.reload();
    }
  }, []);
  return null;
};

export default () => (
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <Helmet>
      <title>{_.get(process.env.APP_CONFIG, ['APP_DETAILS', `${lang.toUpperCase()}_NAME`])}</title>
      <meta name="description" content={_.get(process.env.APP_CONFIG, ['APP_DETAILS', `${lang.toUpperCase()}_DESCRIPTION`])} />
    </Helmet>
    <Provider store={store}>
      <Router history={history}>
        <Route
          exact
          path="/"
          render={() => (
            <Redirect to={`/${lang}`} />
          )}
        />
        <Route
          component={KeyControl}
          path="/:lang"
        />
      </Router>
    </Provider>
  </ErrorBoundary>
);
